/* Simms Knits storefront behaviour: card swatches, reveals, tabs, PDP gallery + variant picker. */
(() => {
  /* ---------- Card swatches ---------- */
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('.k-card .k-swatch');
    if (!sw) return;
    e.preventDefault();
    const card = sw.closest('[data-k-card]');
    card.querySelectorAll('.k-swatch').forEach((b) => b.setAttribute('aria-pressed', b === sw ? 'true' : 'false'));
    const img = card.querySelector('[data-k-card-img]');
    if (img && sw.dataset.src) {
      const next = new Image();
      next.srcset = sw.dataset.srcset;
      next.sizes = img.sizes;
      next.src = sw.dataset.src;
      const swap = () => { img.srcset = sw.dataset.srcset; img.src = sw.dataset.src; };
      next.decode ? next.decode().then(swap, swap) : swap();
    }
    const id = card.querySelector('input[name="id"]');
    if (id) id.value = sw.dataset.variant;
    card.querySelectorAll('a[href*="/products/"]').forEach((a) => { a.href = sw.dataset.url; });
  });

  /* ---------- Reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  const watch = (root) => root.querySelectorAll('.k-reveal:not(.is-in)').forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));
  watch(document);
  document.addEventListener('shopify:section:load', (e) => watch(e.target));

  /* ---------- Tabs (lanes) ---------- */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-k-tab]');
    if (!tab) return;
    const root = tab.closest('[data-k-tabs]');
    root.querySelectorAll('[data-k-tab]').forEach((t) => t.setAttribute('aria-selected', t === tab ? 'true' : 'false'));
    root.querySelectorAll('[data-k-panel]').forEach((p) => { p.hidden = p.dataset.kPanel !== tab.dataset.kTab; });
  });

  /* ---------- Layers steps: highlight the step in view ---------- */
  document.querySelectorAll('[data-k-steps]').forEach((list) => {
    const steps = [...list.querySelectorAll('.k-step')];
    if (!('IntersectionObserver' in window) || !steps.length) return steps.forEach((s) => s.classList.add('is-active'));
    const so = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { steps.forEach((s) => s.classList.toggle('is-active', s === en.target)); } });
    }, { rootMargin: '-45% 0px -45% 0px' });
    steps.forEach((s) => so.observe(s));
    steps[0].classList.add('is-active');
  });

  /* ---------- Product page ---------- */
  const pdp = document.querySelector('[data-k-pdp]');
  if (!pdp) return;
  const data = JSON.parse(pdp.querySelector('[data-k-pdp-json]').textContent);
  const form = pdp.querySelector('form[action*="/cart/add"]');
  const idInput = form.querySelector('input[name="id"]');
  const btn = form.querySelector('[type="submit"]');
  const btnText = btn.querySelector('span');
  const priceEl = pdp.querySelector('[data-k-price]');
  const stickyPrice = document.querySelector('[data-k-sticky-price]');
  const colorName = pdp.querySelector('[data-k-color-name]');
  const gallery = document.querySelector('[data-k-gallery]');
  const money = (c) => '$' + (c % 100 === 0 ? (c / 100).toFixed(0) : (c / 100).toFixed(2));

  const selected = () => {
    const sel = {};
    pdp.querySelectorAll('[data-k-option]').forEach((group) => {
      const on = group.querySelector('input:checked');
      if (on) sel[group.dataset.kOption] = on.value;
    });
    return sel;
  };

  const layoutGallery = () => {
    if (!gallery) return;
    const vis = [...gallery.querySelectorAll('[data-k-media]:not([hidden])')];
    vis.forEach((m, i) => m.classList.toggle('is-wide', i === 0 || (i === vis.length - 1 && (vis.length - 1) % 2 === 1)));
  };
  const showColorMedia = (color) => {
    if (!gallery || !color) return layoutGallery();
    const track = gallery.querySelector('[data-k-track]');
    const items = [...track.querySelectorAll('[data-k-media]')];
    const own = items.filter((m) => m.dataset.color === color);
    if (!own.length) { items.forEach((m) => (m.hidden = false)); return layoutGallery(); }
    own.forEach((m) => { const i = m.querySelector('img'); if (i) i.loading = 'eager'; });
    items.forEach((m) => { m.hidden = !(m.dataset.color === color || m.dataset.color === ''); });
    own.slice().reverse().forEach((m) => track.prepend(m));
    track.scrollLeft = 0;
    layoutGallery();
    const count = gallery.querySelector('[data-k-count]');
    if (count) count.textContent = `1 / ${items.filter((m) => !m.hidden).length}`;
  };

  const update = () => {
    const sel = selected();
    const v = data.variants.find((x) => x.options.every((val, i) => !data.optionNames[i] || sel[data.optionNames[i]] === undefined || sel[data.optionNames[i]] === val));
    pdp.querySelectorAll('[data-k-option]').forEach((group) => {
      const name = group.dataset.kOption;
      const idx = data.optionNames.indexOf(name);
      group.querySelectorAll('input').forEach((inp) => {
        const ok = data.variants.some((x) => x.available && x.options[idx] === inp.value && x.options.every((val, i) => i === idx || sel[data.optionNames[i]] === undefined || sel[data.optionNames[i]] === val));
        inp.closest('label').classList.toggle('is-unavailable', !ok);
      });
    });
    if (sel.Color && colorName) colorName.textContent = sel.Color;
    const needsSize = data.optionNames.includes('Size') && !sel.Size;
    if (!v || needsSize) {
      btn.setAttribute('disabled', '');
      btnText.textContent = needsSize ? 'Choose a size' : 'Unavailable';
      return showColorMedia(sel.Color);
    }
    idInput.value = v.id;
    priceEl && (priceEl.textContent = money(v.price));
    stickyPrice && (stickyPrice.textContent = money(v.price));
    if (v.available) { btn.removeAttribute('disabled'); btnText.textContent = 'Add to bag'; }
    else { btn.setAttribute('disabled', ''); btnText.textContent = 'Sold out'; }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
    showColorMedia(sel.Color);
  };
  pdp.addEventListener('change', (e) => { if (e.target.closest('[data-k-option]')) update(); });
  pdp.addEventListener('pointerover', (e) => {
    const lab = e.target.closest('.k-opt__swatch');
    if (!lab || !gallery) return;
    const c = lab.querySelector('input').value;
    gallery.querySelectorAll(`[data-k-media][data-color="${CSS.escape(c)}"] img`).forEach((i) => { i.loading = 'eager'; });
  });
  update();

  /* phone gallery counter */
  if (gallery) {
    const track = gallery.querySelector('[data-k-track]');
    const count = gallery.querySelector('[data-k-count]');
    track.addEventListener('scroll', () => {
      if (!count) return;
      const vis = [...track.querySelectorAll('[data-k-media]:not([hidden])')];
      const i = Math.round(track.scrollLeft / (track.clientWidth || 1));
      count.textContent = `${Math.min(i + 1, vis.length)} / ${vis.length}`;
    }, { passive: true });
  }

  /* sticky add-to-bag bar */
  const sticky = document.querySelector('[data-k-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    const so = new IntersectionObserver(([en]) => sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0));
    so.observe(btn);
    sticky.querySelector('button').addEventListener('click', () => {
      if (btn.hasAttribute('disabled')) { pdp.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      btn.click();
    });
  }
})();
